define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/reflection",
	"csi/xml"
], function(array, declare, reflection, xml) {

	return declare(null, {
		_mixinActionView: function(/*csi.def.View*/defView) {
			// summary: set controller class for form
			defView.classController = "Apparel.StructureItemForm";
		},

		_onAction: function() {
			// summary: set read-only flag based on if template selected or not
			if (this.m_writer.isChanged()) {
				var cn = this.m_writer.changeNode(this.m_urlNode);
				var form = this.popupView;
				var field;

				var typeNode = this.getActionNodeType();

				var rc = reflection.getClass(typeNode);

				array.forEach(form._attributeIds, function(id) {
					if (field = form.defView.getField(id)) {
						var readOnly = form._bTemplate || rc?.getAttribute(id).isReadOnly;
						cn.changeAttributeFlag(id, xml.ATTR_FLAG_NOEDIT, readOnly, !readOnly);
					}
				});
			}
		}
	});
});